import { client } from '@/services';
import { getSelectedVenue } from '@/services/helpers';
import assets from './assets';

const playlistService = client.service('playlists');
const assetsService = client.service('assets');
const assetsFolderService = client.service('assets_folder');

const assets_folders = {
  namespaced: true,
  state: {
    assets_folders: [],
    loaded: false
  },
  getters: {
    GET_ASSETS_FOLDERS: state => state.assets_folders,
    GET_LOADED_STATUS: state => state.loaded
  },
  mutations: {
    SET_ASSETS_FOLDERS(state, assets) {
      state.assets = assets;
      state.loaded = true;
    }
  },
  actions: {
    async GET_ASSETS_FOLDERS({ commit }) {
      const assets_folders = await assetsFolderService.find({
        query: {
          venueId: getSelectedVenue()._id,
          $paginate: {
            value: false
          }
        }
      });

      commit('SET_ASSETS_FOLDERS', assets_folders);
      return assets_folders;
    },
    async ADD_ASSETS_FOLDER({ rootState }, folder) {
      const clone = JSON.parse(JSON.stringify(folder));

      clone.created_at = Date.now();
      clone.userId = rootState.users.user._id;
      clone.venueId = getSelectedVenue()._id;

      const response = await assetsFolderService.create(clone);

      return response;
    },
    async UPDATE_ASSETS_FOLDER(_, payload) {
      await assetsFolderService.update(payload._id, payload.assets_folder);
    },
    async PATCH_ASSETS_FOLDER(_, payload) {
      await assetsFolderService.patch(payload._id, payload);
    },
    async DELETE_ASSETS_FOLDERS({ commit, dispatch }, payload) {
      try {
        let foldersDeleted = [];

        for (let folderId of payload.folders) {
          const assets = await assetsService.find({
            query: {
              assetsFolderId: folderId
            }
          });

          if (assets.total < 1) {
            await assetsFolderService.remove(folderId);
            foldersDeleted.push(folderId);
          }
        }

        return foldersDeleted;
      } catch (error) {
        throw error;
      }
    }
  }
};

export default assets_folders;



// WEBPACK FOOTER //
// ./src/store/modules/assets_folders.js